import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { BottomNav } from "@/components/Nav";

function today() { return new Date().toISOString().slice(0,10); }

export default function CheckIn() {
  const [history, setHistory] = useState([]);
  const [form, setForm] = useState({ date: today(), nutrition_on_track: true, workout_done: false, water_litres: 2.5, sleep_hours: 7, discipline_score: 8, energy_score: 7, mood: "", notes: "" });
  const [err, setErr] = useState("");
  const [ok, setOk] = useState(false);

  const load = async () => {
    const { data } = await api.get("/checkins");
    setHistory(data);
  };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setOk(false);
    try {
      await api.post("/checkins", form);
      setOk(true); load();
    } catch (e) { setErr(formatApiError(e)); }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white safe-pb">
      <div className="max-w-xl mx-auto px-4 pt-6">
        <h1 className="font-display font-black uppercase text-3xl tracking-tighter">Daily check-in</h1>
        <p className="text-neutral-400 text-sm mt-1">Discipline is built one honest check-in at a time.</p>

        <form onSubmit={submit} className="kw-card p-4 mt-4 space-y-3">
          <div><label className="kw-label">Date</label><input className="kw-input" type="date" value={form.date} onChange={e=>setForm({...form,date:e.target.value})} data-testid="ci-date"/></div>
          <label className="flex items-center justify-between text-sm">
            <span>Nutrition on track?</span>
            <input type="checkbox" checked={form.nutrition_on_track} onChange={e=>setForm({...form,nutrition_on_track:e.target.checked})} data-testid="ci-nut"/>
          </label>
          <label className="flex items-center justify-between text-sm">
            <span>Workout / walk done?</span>
            <input type="checkbox" checked={form.workout_done} onChange={e=>setForm({...form,workout_done:e.target.checked})} data-testid="ci-work"/>
          </label>
          <div className="grid grid-cols-2 gap-2">
            <div><label className="kw-label">Water (L)</label><input className="kw-input" type="number" step="0.1" value={form.water_litres} onChange={e=>setForm({...form,water_litres:parseFloat(e.target.value||"0")})} data-testid="ci-water"/></div>
            <div><label className="kw-label">Sleep (hrs)</label><input className="kw-input" type="number" step="0.1" value={form.sleep_hours} onChange={e=>setForm({...form,sleep_hours:parseFloat(e.target.value||"0")})} data-testid="ci-sleep"/></div>
          </div>
          <div>
            <label className="kw-label">Discipline score (1–10): {form.discipline_score}</label>
            <input type="range" min="1" max="10" value={form.discipline_score} onChange={e=>setForm({...form,discipline_score:parseInt(e.target.value)})} className="w-full accent-[#D4AF37]" data-testid="ci-discipline"/>
          </div>
          <div>
            <label className="kw-label">Energy score (1–10): {form.energy_score}</label>
            <input type="range" min="1" max="10" value={form.energy_score} onChange={e=>setForm({...form,energy_score:parseInt(e.target.value)})} className="w-full accent-[#D4AF37]" data-testid="ci-energy"/>
          </div>
          <div>
            <label className="kw-label">Mood today</label>
            <div className="grid grid-cols-5 gap-1">
              {["low","flat","ok","strong","fired-up"].map(m => (
                <button key={m} type="button" onClick={()=>setForm({...form,mood:m})} className={`py-2 border uppercase text-[10px] tracking-widest ${form.mood===m?"border-gold text-gold":"border-[#333] text-neutral-400"}`} data-testid={`ci-mood-${m}`}>{m}</button>
              ))}
            </div>
          </div>
          <div><label className="kw-label">Notes</label><textarea className="kw-input" rows={3} value={form.notes} onChange={e=>setForm({...form,notes:e.target.value})} data-testid="ci-notes"/></div>
          {err && <div className="text-red-400 text-sm">{err}</div>}
          {ok && <div className="text-gold text-sm" data-testid="ci-ok">Check-in saved. Discipline logged.</div>}
          <button className="kw-btn-primary w-full" data-testid="ci-submit">Submit check-in</button>
        </form>

        <div className="mt-6 space-y-2">
          <div className="text-xs uppercase tracking-widest text-neutral-500">Recent check-ins</div>
          {history.slice(0,10).map(h => (
            <div key={h.id} className="kw-card p-3">
              <div className="flex justify-between items-center">
                <div className="text-sm font-semibold">{h.date}</div>
                <div className="text-xs text-gold font-bold">{h.discipline_score}/10</div>
              </div>
              <div className="text-xs text-neutral-500 mt-1">Nutrition {h.nutrition_on_track?"✓":"✗"} · Workout {h.workout_done?"✓":"✗"} · Water {h.water_litres}L · Sleep {h.sleep_hours}h {h.energy_score ? `· Energy ${h.energy_score}/10` : ""} {h.mood ? `· ${h.mood}` : ""}</div>
              {h.notes && <div className="text-xs text-neutral-400 mt-1">{h.notes}</div>}
            </div>
          ))}
        </div>
      </div>
      <BottomNav />
    </div>
  );
}
